<section class="dashboard-no-orders__section" data-cy="dashboard-no-orders__section">
	<div class="panel__wrapper">
		<div class="panel__info-row">
			<div class="info-row__column">
				<img class="info-row__image" data-cy="dashboard-no-orders__icon" src="/assets/icons/info-icon.svg" alt="info-icon"/>
			</div>
			<div class="info-row__column info-row__button-column">
				<div class="info-row__label h5">{{ 'dashboard.no_orders_associated' | locale: merchantLocaleSuffix }}</div>
				<div class="info-row__label mat-body-2">{{ 'dashboard.no_orders_description' | locale: merchantLocaleSuffix }}</div>
				<gap-button data-cy="dashboard-no-orders__link-order-button">{{ 'dashboard.link_order_button' | locale: merchantLocaleSuffix }}</gap-button>
			</div>
		</div>
		<div class="panel__info-row full-width__button">
			<gap-button data-cy="dashboard-no-orders__link-order-button">{{ 'dashboard.link_order_button' | locale: merchantLocaleSuffix }}</gap-button>
		</div>
	</div>
</section>
